import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { Game, Mobile, Realty } from "../../../app-constants";
import Modal from "react-bootstrap/Modal";
import Downloadform from "../components/downloadform";
import { StaticImage } from "gatsby-plugin-image";

function DekstopHeaderOld({ lang }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <nav className="tekrevol_menu deskstop_view text-end">
        <ul>
          <li>
            <Link to="/" className="nav_link" activeClassName="active">
              Home
            </Link>
          </li>
          <li className="mega">
            <Link to="/services" className="nav_link">
              Services
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="cateorgy_namee">
                      <h4 className="ps-0">Our Services</h4>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/ebook_header.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1050}
                          height={650}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Primary</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/mobile-app-development">
                            Mobile App Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/android-app-development">
                            Android App Development
                          </Link>
                        </li>

                        <li>
                          <Link to="/iphone-app-development">
                            IPhone App Development
                          </Link>
                        </li>

                        <li>
                          <Link to="/game-development">Game Development</Link>
                        </li>
                        <li>
                          <Link to="/web-development">Web Development</Link>
                        </li>

                        <li>
                          <Link to="/custom-software-development">
                            Custom Software Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/flutter-app-development">
                            Flutter App Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Consulting</h4>
                      <ul className="menu_items ">
                        <li>
                          <Link to="/cloud-computing-consultants">
                            Cloud Computing
                          </Link>
                        </li>
                        <li>
                          <Link to="/cto-consultant">CTO Consultant</Link>
                        </li>
                        <li>
                          <Link to="/emerging-technology-solutions">
                            Emerging Technology
                          </Link>
                        </li>
                        <li>
                          <Link to="/digital-transformation-company">
                            Digital Transformation
                          </Link>
                        </li>
                        <li>
                          <Link to="/digital-marketplace">
                            Digital Marketplace
                          </Link>
                        </li>
                        <li>
                          <Link to="/data-analytics-solutions">
                            Data Analytics
                          </Link>
                        </li>
                        <li>
                          <Link to="/digital-strategy-consultant">
                            Digital Strategy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Trending</h4>
                      <ul className="menu_items ">
                        <li>
                          <Link to="/ai-development-company">
                            AI Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/ar-vr-company">AR/VR Company</Link>
                        </li>
                        <li>
                          <Link to="/bluetooth-app-development">
                            Bluetooth App Development
                          </Link>
                        </li>
                        <li>
                          <Link to="/automation-consultancy">
                            Automation Consultancy
                          </Link>
                        </li>
                        <li>
                          <Link to="/nft-development">NFT Development</Link>
                        </li>
                        <li>
                          <Link to="/machine-learning-company">
                            Machine Learning
                          </Link>
                        </li>
                        <li>
                          <Link to="/react-native-app-development">
                            React Native App Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
                <Row className="darkbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="core_namee">
                      <h4 className="mb-0">Core Services</h4>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Mobile}</div>
                      <div className="menu_items">
                        <Link to="/mobile-app-development">
                          Mobile Application
                          <span>IOS, Android and wearable Apps</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Game}</div>
                      <div className="menu_items">
                        <Link to="/game-development">
                          Game Development
                          <span>2D, 3D and Isometric Games</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Realty}</div>
                      <div className="menu_items">
                        <Link to="/custom-software-development">
                          Software Development
                          <span>Startups & Enterprises</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          <li className="mega">
            <Link to="/solution" className="nav_link">
              Solution{" "}
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="cateorgy_namee">
                      <h4 className="ps-0">Our Solution</h4>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/ebook_header.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1050}
                          height={650}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Products</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/cms-development">CMS Solution</Link>
                        </li>
                        <li>
                          <Link to="/solution/hrm-development">
                            HRM Solution
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/crm-developers">
                            CRM Solution
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/erp-developers">
                            ERP Solution
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/custom-lms-development">
                            LMS Solution
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/pos-development">
                            POS Solution
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Industries</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/solution/automotive-app-development">
                            Automotive
                          </Link>
                        </li>

                        <li>
                          <Link to="/healthcare-app-development">
                            Healthcare
                          </Link>
                        </li>
                        <li>
                          <Link to="/on-demand-app-development">On-Demand</Link>
                        </li>
                        <li>
                          <Link to="/solution/educational-software-company">
                            Education
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/music-app-developers">Music</Link>
                        </li>
                        <li>
                          <Link to="/fintech-software-development">
                            Fintech
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>&nbsp;</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/solution/logistics-software-development">
                            Logistics
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/retail-software-solution">
                            {" "}
                            Retail
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/ecommerce-app-development">
                            Ecommerce
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/real-estate-app-development">
                            {" "}
                            Real Estate
                          </Link>
                        </li>
                        <li>
                          <Link to="/solution/it-staff-augmentation">
                            Staff Augmentation
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
                <Row className="darkbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="core_namee">
                      <h4 className="mb-0">Core Services</h4>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Mobile}</div>
                      <div className="menu_items">
                        <Link to="/mobile-app-development">
                          Mobile Application
                          <span>IOS, Android and wearable Apps</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Game}</div>
                      <div className="menu_items">
                        <Link to="/game-development">
                          Game Development
                          <span>2D, 3D and Isometric Games</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Realty}</div>
                      <div className="menu_items">
                        <Link to="/custom-software-development">
                          Software Development
                          <span>Startups & Enterprises</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          <li className="mega">
            <Link to="/technologies" className="nav_link">
              Technologies{" "}
            </Link>
            <div className="mega_menu">
              <Container>
                <Row className="lightbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="cateorgy_namee">
                      <h4 className="ps-0">Our Technologies</h4>
                      <div className="menu_content" onClick={handleShow}>
                        <StaticImage
                          src="../../images/ebook_header.webp"
                          alt="mobile app development company"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={1050}
                          height={650}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col
                    xs={12}
                    md={3}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="ps-0"
                  ></Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Languages</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/dot-net-development">.Net </Link>
                        </li>
                        <li>
                          <Link to="/html5-development">HTML5</Link>
                        </li>
                        <li>
                          <Link to="/java-development">Java</Link>
                        </li>
                        <li>
                          <Link to="/hire-nodejs-developers">Node.js</Link>
                        </li>
                        <li>
                          <Link to="/php-development">PHP</Link>
                        </li>
                        <li>
                          <Link to="/python-development">Python</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3}>
                    <div className="cateorgy_namee">
                      <h4>Platforms</h4>
                      <ul className="menu_items">
                        <li>
                          <Link to="/azure-consultant">Azure</Link>
                        </li>
                        <li>
                          <Link to="/gcp-cloud">GCP</Link>
                        </li>
                        <li>
                          <Link to="/oracle-solution">Oracle</Link>
                        </li>
                        <li>
                          <Link to="/sap-consultant">SAP</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>

                <Row className="darkbg_menu">
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="m-auto">
                    <div className="core_namee">
                      <h4 className="mb-0">Core Services</h4>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Mobile}</div>
                      <div className="menu_items">
                        <Link to="/mobile-app-development">
                          Mobile Application
                          <span>IOS, Android and wearable Apps</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Game}</div>
                      <div className="menu_items">
                        <Link to="/game-development">
                          Game Development
                          <span>2D, 3D and Isometric Games</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={3} lg={3} xl={3} xxl={3} className="my-auto">
                    <div className="core_menu">
                      <div className="core_icon">{Realty}</div>
                      <div className="menu_items">
                        <Link to="/custom-software-development">
                          Software Development
                          <span>Startups & Enterprises</span>
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </li>
          {/* <li className="mega">
            <Link to="/location" className="nav_link">
              Location
            </Link>
          </li> */}
          <li>
            <Link to="/projects" className="nav_link">
              Portfolio
            </Link>
          </li>
          <li className="sub not-mobile">
            <Link to="#" className="nav_link">
              Insights
            </Link>
            <div className="submenu">
              <ul>
                <li>
                  <Link to="/about">About TekRevol</Link>
                </li>
                <li>
                  <Link to="/life-at-tekrevol">Life at TekRevol</Link>
                </li>
                <li>
                  <Link href="/blogs/">Blogs</Link>
                </li>
                <li>
                  <Link to="/press-release">Press</Link>
                </li>
                <li>
                  <Link to="/podcast">Podcast</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>
                <li>
                  <Link to="/referral-program">Referral Program</Link>
                </li>
              </ul>
            </div>
          </li>
          {lang === "arbic_dubai" ? (
            <li>
              <Link
                to="/mobile-app-development-company-dubai"
                className="nav_link"
              >
                EN
              </Link>
            </li>
          ) : lang === "eng_dubai" ? (
            <li>
              <Link to="/ar/تصميم-تطبيقات-الجوال-في-دبي" className="nav_link">
                عربي
              </Link>
            </li>
          ) : lang === "arbic_saudi" ? (
            <li>
              <Link
                to="/sa/mobile-apps-development-in-saudi-arabia"
                className="nav_link"
              >
                EN
              </Link>
            </li>
          ) : lang === "eng_saudi" ? (
            <li>
              <Link
                to="/sa/تصميم-تطبيقات-الجوال-في-السعودية"
                className="nav_link"
              >
                عربي
              </Link>
            </li>
          ) : (
            ""
          )}
          <li>
            <Link
              to="/contact"
              className="btn_primary"
              aria-label="TekRevol Contact"
            >
              Get A Quote
            </Link>
          </li>
        </ul>
      </nav>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal_forms">
          <Downloadform setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default DekstopHeaderOld;
